import React from "react";
import styled from "@emotion/styled";
import { useThemeUI } from "theme-ui";
import titleImg from "./assets/logo.png";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
  height: 100vh;
  width: 80vw;
  z-index: 2;
`;

const Centered = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TopTitle = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 140px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 86px;
`;

const Logo = styled.img`
  height: 35vh;
`;

const BottomTitle = styled.div`
  font-family: Roboto;
  font-size: 140px;
  letter-spacing: -0.5px;
  font-weight: 400;
  text-align: center;
  color: #eec42b;
  margin-top: 86px;
`;

export const TitlePage = () => {
  const { theme } = useThemeUI();
  return (
    <Wrapper theme={theme}>
      <Centered>
        <TopTitle>React Native</TopTitle>
        <Logo src={titleImg} />
        <BottomTitle>+ JustWatch</BottomTitle>
      </Centered>
    </Wrapper>
  );
};
